import React from "react";
import { FormItem } from "..";

class ConfirmationCheck extends FormItem {
  renderReadonly() {
    const self = this;
    // childrenがブロックレベル要素である可能性があるため、pではなくdivで囲っておく
    return (
      <div className="mb-0">
        {self.isChecked() ? (
          self.props.children
        ) : (
          <del>{self.props.children}</del>
        )}
      </div>
    );
  }
  isChecked() {
    const self = this;
    return Boolean(self.getVal());
  }
  renderInput() {
    const self = this;
    return (
      <div>
        <label className="custom-control custom-control-inline custom-checkbox mb-0">
          <input
            type="checkbox"
            className="custom-control-input"
            checked={self.isChecked()}
            onChange={() => {
              self.setVal(self.getVal() ? null : 1);
            }}
          />
          <div className="custom-control-label">{self.props.children}</div>
        </label>
        {self.renderValError()}
      </div>
    );
  }
}
export default ConfirmationCheck;
